"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyValue = stringifyValue;
const date_utils_1 = require("./date-utils");
function stringifyValue(value, details) {
    if (value === undefined) {
        return "";
    }
    if (details.type === "date" || value instanceof Date) {
        if (details.format === "iso") {
            return (0, date_utils_1.formatDateIso)(value) || String(value);
        }
        return (0, date_utils_1.formatDateMonthDayYear)(value) || String(value);
    }
    if (Array.isArray(value)) {
        return value
            .map(v => stringifyValue(v, details))
            .join(details.separator || ",");
    }
    return String(value);
}
//# sourceMappingURL=stringify-value.js.map